module.exports = __webpack_public_path__ + "img/closeBtn.f9d734d7.svg";